import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { ArrowRightIcon } from '@fiverr-private/visuals';
import { Image } from '@fiverr-private/media';
import { Box } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';
import type { NicheCardProps } from './NicheCard.types';
import { linkCardImage, selectedCardImage } from './NicheCard.ve.css';
import { LINK_IMAGE_SIZE } from './NicheCard.constants';

interface NicheCardContentProps extends Pick<NicheCardProps, 'displayName' | 'url'> {
    imageSize?: number;
    isSelected?: boolean;
}

export const NicheCardContent: React.FC<NicheCardContentProps> = ({
    displayName,
    url,
    imageSize = LINK_IMAGE_SIZE,
    isSelected = false,
}) => (
    <Stack direction="column" gap="4">
        <Box
            as="span"
            className={`${linkCardImage} ${isSelected ? selectedCardImage : ''}`}
            borderRadius="lg"
            width={imageSize}
            height={imageSize}
            overflow="hidden"
        >
            <Image src={url} alt={displayName} width={imageSize} height={imageSize} />
        </Box>
        <Stack alignItems="flexStart" justifyContent="spaceBetween" color="grey_1200" width={imageSize}>
            <Text as="span" fontWeight="semibold" wordBreak="keepAll" size="b_md">
                {displayName}
            </Text>
            {imageSize === LINK_IMAGE_SIZE && (
                <Stack direction="column" justifyContent="center" alignItems="center" height="24px">
                    <ArrowRightIcon />
                </Stack>
            )}
        </Stack>
    </Stack>
);

NicheCardContent.displayName = 'NicheCardContent';
